import React from 'react';
import { isEmpty } from 'lodash';
import { Button, Icon, Spinner } from 'ui';
import AddToCalendar from 'components/InPersonTraining/EventRegistrationOverview/AddToCalendar';
import Tooltip from 'components/shared/Tooltip';
import classNames from 'classnames';

const AttendanceForm = ({
  pastEvent,
  handleUpdateAttendance,
  handleChangeAttendance,
  showRsvpButtons,
  canChangeAttendance,
  eventAtCapacity,
  showAddToCalendar,
  event,
  session,
  attendance,
  selectedSessionId,
  hasMultipleSessions,
  registrationSubmitting,
  notAttendingSubmitting,
  previewing = false,
  isPositiveAttendance = false,
}) => {
  const rsvpType = event.rsvp_type || event.rsvpType;
  const isAddToCalendarAvailable =
    !showRsvpButtons() && showAddToCalendar() && !isEmpty(session);
  const isChangeRsvpAvailable =
    !showRsvpButtons() &&
    (canChangeAttendance || !pastEvent) &&
    (!eventAtCapacity || isPositiveAttendance);

  const willAttendButtonDisabled =
    hasMultipleSessions && rsvpType === 'single' && !selectedSessionId;

  return (
    <div>
      {showRsvpButtons() && (
        <>
          <Button
            className={classNames('EventRegistration-AttendanceButton', {
              previewing,
            })}
            onClick={() => handleUpdateAttendance(true)}
            disabled={willAttendButtonDisabled || previewing}
          >
            <Tooltip
              position="top"
              text={
                willAttendButtonDisabled
                  ? t(
                      'in_person_training.events.register.rsvp_will_attend_disabled',
                    )
                  : null
              }
            >
              <>
                {registrationSubmitting ? (
                  <Spinner className="mr-16" />
                ) : (
                  <Icon name="correct" />
                )}
                {pastEvent
                  ? t('in_person_training.rsvp_status.did_attend')
                  : t('in_person_training.rsvp_status.will_attend')}
              </>
            </Tooltip>
          </Button>
          <Button
            className={classNames('EventRegistration-AttendanceButton', {
              previewing,
            })}
            onClick={() => handleUpdateAttendance(false)}
            disabled={previewing}
          >
            {notAttendingSubmitting ? (
              <Spinner className="mr-16" />
            ) : (
              <Icon name="incorrect" />
            )}
            {pastEvent
              ? t('in_person_training.rsvp_status.did_not_attend')
              : t('in_person_training.rsvp_status.will_not_attend')}
          </Button>
        </>
      )}
      {isChangeRsvpAvailable && (
        <Button
          type="button"
          onClick={handleChangeAttendance}
          className="mr-12"
        >
          {t('in_person_training.rsvp_details.change_rsvp')}
        </Button>
      )}
      {isAddToCalendarAvailable && (
        <AddToCalendar className="mr-12" event={event} session={session} />
      )}
    </div>
  );
};

export default AttendanceForm;
